<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      top="5vh"
      v-loading="loading"
      :append-to-body="true"
  >
    <div class="dialog-content" style="padding-right:20px;">
      <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          label-width="120px"
      >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="订单编号：" prop="agreementCode">
              <OrderDrop v-model="dataForm.agreementCode" :disabled="true"
                         placeholder="请输入订单编号"></OrderDrop>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="optName + '时间：'" prop="operateTime">
              <el-date-picker
                  v-model="dataForm.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :placeholder="`选择出${optName}时间`"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="optName + '仓库：'" prop="storageId">
              <storages v-model="dataForm.storageId" :disabled="true"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流公司：" prop="carriageMan">
              <dict v-model="dataForm.carriageMan" dictName="carriage_man"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流号：" prop="carriageNo">
              <el-input v-model="dataForm.carriageNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：" prop="remark">
              <el-input
                  v-model="dataForm.remark"
                  placeholder="备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="凭证照片：" prop="imgs">
          <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
        </el-form-item>

        <el-card style="margin-top:20px;">
          <div slot="header" class="card-header">
            <div>{{ optName }}明细</div>
          </div>
          <el-table :data="dataForm.detailList" :max-height="335" border style="width: 100%">
            <el-table-column
                type="index"
                width="50"
                label="行号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                label="品番号"
                prop="code"
                align="center"
                v-if="productType === '产品'"
            >
              <template slot-scope="scope">
                <span >{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column label="品名" prop="name" align="center">
              <template slot-scope="scope">
                <span >{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="color" align="center">
              <template slot-scope="scope">
                <span >{{ scope.row.color }}</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="size" align="center">
              <template slot-scope="scope">
                <span >{{ scope.row.size }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="幅宽"
                prop="attr1"
                align="center"
                v-if="productType === '原料'"
            >
              <template slot-scope="scope">
                <span >{{ scope.row.attr1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="克重"
                prop="attr2"
                align="center"
                v-if="productType === '原料'"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.attr2 }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="当前库存"
                prop="oldCount"
                header-align="center"
                align="center"
                width="120"
            ></el-table-column>
            <el-table-column
                label="本次数量"
                header-align="center"
                align="center"
                width="160"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.count'"
                    :rules="detailRule.count"
                    label-width="0"
                    style="margin-top: 20px"
                >
                  <el-input v-model="scope.row.count" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
                label="B品数量"
                header-align="center"
                align="center"
                width="160"
                v-if="hasCountB"
            >
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.countB'"
                    :rules="detailRule.countB"
                    label-width="0"
                    style="margin-top: 20px"
                >
                  <el-input v-model="scope.row.countB" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </div>
    <template slot="footer">
      <el-button @click="cancel()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t("confirm")
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import OrderDrop from '@/components/order-drop'
import debounce from "lodash/debounce";
import MultipleImageUpload from "@/components/MultipleImageUpload";
import SaveRule from "./form-rule";
import moment from "moment";

export default {
  mixins: [SaveRule],
  components: {MultipleImageUpload, OrderDrop},
  data() {
    return {
      id: "",
      dataForm: {},
      visible: false,
      loading: false,
      hasCountB: window.SITE_CONFIG["hasCountB"],
      productType: "",
      title: "",
      storeType: "",
      storeTypeName: {
        "1": "入库",
        "-1": "出库",
      },
    };
  },
  watch: {},
  computed: {
    canEditDetail() {
      return true
    },
    optName() {
      return this.storeTypeName[String(this.storeType)];
    },
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    async reset() {
      this.imgArr = [];
      this.dataForm = {
        id: "",
        remark: "",
        operateTime: '',
        storageId: "",
        carriageNo: "",
        carriageMan: "",
        imgs: "",
        agreementCode: "",
        detailList: [],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        this.getInfo()
      });
    },
    getInfo() {
      if (!this.id) {
        return
      }
      this.$http.get(`/trade/factorystorelog/${this.id}`).then(({data: res}) => {
        this.dataForm={
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.detailList=[
          {
            code: res.data.productCode,
            name: res.data.productName,
            productId: res.data.productId,
            oldCount: res.data.storeCount,
            color: res.data.color,
            size: res.data.size,
            attr1:res.data.attr1,
            attr2:res.data.attr2,
            count: res.data.count,
            countB: res.data.countB
          }
        ]
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs["dataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            if (
                !this.dataForm.detailList ||
                this.dataForm.detailList.length === 0
            ) {
              return this.$message.error("明细不能为空");
            }
            let postForm = [];
            this.dataForm.detailList.forEach((item) => {
              postForm.push({
                ...this.dataForm,
                countB: item.countB,
                count: item.count,
                productName: item.name,
                productCode: item.code,
                size: item.size,
                color: item.color,
                attr1: item.attr1,
                attr2: item.attr2,
                productType: this.productType,
              });
            });
            this.loading = true;
            this.$http
                .post("/trade/factorystorelog/update", postForm[0])
                .then(({data: res}) => {
                  this.loading = false;
                  if (res.code !== 0) {
                    return this.$message.error(res.msg);
                  }
                  this.$message({
                    message: this.$t("prompt.success"),
                    type: "success",
                    duration: 500,
                    onClose: () => {
                      this.cancel();
                      this.$emit("refreshDataList");
                    },
                  });
                })
                .catch((e) => {
                  console.log(e);
                  this.loading = false;
                });
          });
        },
        1000,
        {leading: true, trailing: false}
    ),
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
